/* eslint-disable  no-extra-boolean-cast */
import { FC } from 'react';
import { useTranslationContext } from '../../contexts/translationContext';
import { ArrowBack } from '../../uiLibraryImports';
import styles from './emailSent.module.scss';

const EmailSentMessage: FC<EmailSentMessageProps> = (props: EmailSentMessageProps) => {
    const { sentTo, onBackToLogin } = props;
    const { translate } = useTranslationContext();

    return (
        <div id="email-sent-message" className={styles['verification-email']}>
            <div className={styles['left-title']}>{translate('JustOneMoreStep')}</div>
            <div>
                <div className={styles.text}>{translate('confirmationSent')}</div>
                <div className={styles['text-email']}>{sentTo}</div>
                <br />
                <div className={styles.text}>{translate('checkMessage')}</div>
            </div>
            <div className="back-to-login" onClick={() => onBackToLogin()}>
                <ArrowBack className="arrow-back" />
                <div data-testid="text">{translate('BackToLogin')}</div>
            </div>
        </div>
    );
};

interface EmailSentMessageProps {
    onBackToLogin: Function;
    sentTo: string;
}

export default EmailSentMessage;
